import { List, Map } from 'immutable';
import { constants as logConstants } from '@saucelabs/sl-component-log';
import Colors from '@saucelabs/sl-style-main/lib/variables.css';

const GRAPH1_COLOR = Colors.brandBlueDark;
const GRAPH2_COLOR = Colors.brandWarning;
const GRAPH3_COLOR = Colors.brandSubscriptionEnterprise;
// const GRAPH4_COLOR = Colors.brandYellowLight; // BACKUP COLOR

export const DEFAULT_X_MAX_AMOUNT = 350;
export const DEFAULT_X_MIN_AMOUNT = 350;

export const ANDROID_CHART_LAYOUT = List([
  Map({
    groupName: 'CPU',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          cpu_total: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
          cpu_user: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
          cpu_kernel: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH3_COLOR },
        }),
        title: 'CPU Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100, // TODO: Calculate actual max value based on number of processors for the device // LT-591
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          n_threads: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Process Thread Count',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100,
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Memory',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          memory_size_kb: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
          memory_resident_kb: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
          memory_shared_kb: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH3_COLOR },
        }),
        title: 'Memory Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e6, // TODO: Calculate actual max value based on the device's capabilities // LT-592
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Network',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          network_wifi_receive_b: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          network_wifi_sent_b: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Wifi Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e8, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          network_mobile_receive_b: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          network_mobile_sent_b: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Mobile Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e8, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
    ]),
  }),
]);

export const IOS_CHART_LAYOUT = List([
  Map({
    groupName: 'CPU',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          cpu_total: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
          cpu_process: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'CPU Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100, // TODO: Calculate actual max value based on number of processors for the device // LT-591
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          n_threads: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Process Thread Count',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100,
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Memory',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          process_memory_used_b: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
        }),
        title: 'Memory Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e6, // TODO: Calculate actual max value based on the device's capabilities // LT-592
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Network',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          net_bytes_in: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          net_bytes_out: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Bytes',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e8, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          net_packets_in: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          net_packets_out: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Packets',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e7, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Disk',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          disk_write_ops: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Number of Operations',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e5, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          disk_bytes_written: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          disk_bytes_written_process: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Bytes Written',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e9, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
    ]),
  }),
]);

// Same as IOS_CHART_LAYOUT, but "Bytes written" doesn't have "disk_bytes_writte_process"
export const IOS_CHART_LAYOUT_LEGACY = List([
  Map({
    groupName: 'CPU',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          cpu_total: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
          cpu_process: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'CPU Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100, // TODO: Calculate actual max value based on number of processors for the device // LT-591
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          n_threads: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Process Thread Count',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 100,
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Memory',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          process_memory_used_b: { type: logConstants.GRAPH_TYPES.AREA, color: GRAPH1_COLOR },
        }),
        title: 'Memory Usage',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e6, // TODO: Calculate actual max value based on the device's capabilities // LT-592
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Network',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          net_bytes_in: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          net_bytes_out: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Bytes',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e8, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          net_packets_in: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
          net_packets_out: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH2_COLOR },
        }),
        title: 'Packets',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e7, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
    ]),
  }),
  Map({
    groupName: 'Disk',
    charts: List([
      Map({
        data: [],
        graphConfigs: Map({
          disk_write_ops: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Number of Operations',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e5, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
      Map({
        data: [],
        graphConfigs: Map({
          disk_bytes_written: { type: logConstants.GRAPH_TYPES.LINE, color: GRAPH1_COLOR },
        }),
        title: 'Bytes Written',
        xMaxAmount: DEFAULT_X_MAX_AMOUNT,
        xMinAmount: DEFAULT_X_MIN_AMOUNT,
        yMaxDefault: 1e9, // TODO: Provide best possible default values // LT-593
        yMinDefault: 0,
      }),
    ]),
  }),
]);
